import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { fullMenu } from "../mock";

export default function Menu() {
  const categories = Object.keys(fullMenu);
  const [active, setActive] = useState(categories[0]);

  return (
    <>
      {/* Header */}
      <section
        className="relative h-[55vh] min-h-[420px] flex items-center justify-center text-center bg-cover bg-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(10,36,36,0.72), rgba(10,36,36,0.88)), url(/image/siteimages/menu/photo-1585937421612-70a008356fbe.jpg)"
        }}
      >
        <div className="absolute inset-0 grain-overlay" />
        <div className="relative pt-20">
          <span className="divider-ornament text-spice-gold">Coastal Fusion Cuisine</span>
          <h1 className="font-display text-white text-5xl md:text-6xl lg:text-7xl font-medium tracking-tight mt-5">
            Our <em className="italic text-spice-gold font-light">Menu</em>
          </h1>
          <p className="text-white/75 mt-4 max-w-xl mx-auto text-base px-5">
            From the tandoor to the grill — every dish is crafted with care, fresh from our open kitchen.
          </p>
        </div>
      </section>

      {/* Sticky category nav */}
      <div className="sticky top-20 lg:top-24 z-40 bg-cream/95 backdrop-blur border-b border-sea-deep/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 flex gap-2 lg:gap-3 overflow-x-auto py-4 scrollbar-hide">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => {
                setActive(cat);
                const el = document.getElementById(cat);
                if (el) {
                  const y = el.getBoundingClientRect().top + window.scrollY - 180;
                  window.scrollTo({ top: y, behavior: "smooth" });
                }
              }}
              className={`whitespace-nowrap px-5 py-2 text-xs lg:text-sm tracking-[0.15em] uppercase border transition-all duration-300 ${
                active === cat
                  ? "bg-sea-deep text-spice-gold border-sea-deep"
                  : "bg-transparent text-sea-mid border-sea-deep/20 hover:border-spice-gold hover:text-spice-gold"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Menu body */}
      <section className="py-20 lg:py-24 bg-cream">
        <div className="max-w-5xl mx-auto px-5 lg:px-10">
          {categories.map((cat) => (
            <div key={cat} id={cat} className="mb-20 scroll-mt-44">
              <div className="flex items-center gap-5 mb-10">
                <h2 className="font-display text-sea-deep text-3xl md:text-4xl lg:text-5xl font-medium">
                  {cat}
                </h2>
                <div className="flex-1 h-px bg-spice-gold/40" />
              </div>
              <div className="grid md:grid-cols-2 gap-x-12 gap-y-8">
                {fullMenu[cat].map((item) => (
                  <div key={item.name} className="group">
                    <div className="flex justify-between items-baseline gap-4 mb-2">
                      <h3 className="font-display text-sea-deep text-xl group-hover:text-spice-gold transition-colors">
                        {item.name}
                      </h3>
                      <div className="flex-1 border-b border-dashed border-sea-deep/20 mb-2" />
                      <span className="font-display text-spice-gold text-lg font-semibold">
                        {item.price}
                      </span>
                    </div>
                    <p className="text-sea-mid/75 text-sm leading-relaxed pr-4">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-sea-deep text-center text-white">
        <div className="max-w-2xl mx-auto px-5">
          <h3 className="font-display text-3xl md:text-4xl mb-4">
            Hungry for more?
          </h3>
          <p className="text-white/75 mb-7">Book your table and let our chefs take care of the rest.</p>
          <Link to="/reservations">
            <Button className="bg-spice-gold hover:bg-[hsl(38_75%_46%)] text-[#0d2929] font-semibold rounded-none px-10 h-14">
              Reserve a Table
            </Button>
          </Link>
        </div>
      </section>
    </>
  );
}
